<template>
  <div class="content">
    <div class="top">
      <div class="elec_speed">
        <el-steps :active="3" finish-status="success" simple>
          <el-step :title=selectedSeries></el-step>
          <el-step :title=loadCondition></el-step>
          <el-step :title=reducerSize></el-step>
          <el-step :title=selectMotor></el-step>
          <el-step :title=complete></el-step>
        </el-steps>
      </div>
    </div>
    <div class="elec_select">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple elec_select_left">
            <img src="../../../static/seriesPic/ele.png" alt="">
            <div class="text">{{$t('message.motorSelection')}}</div>
          </div>
        </el-col>

        <!-- 多级选择菜单 -->
        <el-col :span="12">
          <div class="grid-content bg-purple-light elec_select_right">
            <div class="select_box">
              <div>
                <span style="padding-right:10px;">{{$t('message.title08')}}</span>
                <el-cascader
                  :options="options"
                  v-model="selectedOptions"
                  :props="optionProps"
                  @change="handleChange"
                  :show-all-levels="false">
                </el-cascader>
              </div>
              <div style="padding-top:30px;">
                <span style="padding-right:10px;">{{$t('message.title09')}}</span>
                <el-cascader
                  :options="options_2"
                  v-model="selectedOptions_2"
                  :props="optionProps_2"
                  @change="handleChange_2"
                  @click.native="_getmotortypelist()"
                  :show-all-levels="false">
                </el-cascader>
              </div>
              <span class="returnPage" @click="returnPage">{{$t('message.Return')}}</span>
              <span class="toNextPage" @click="toNextPage">{{$t('message.Next')}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 备注 -->
    <div class="elec_detail">
      <el-row>
        <el-col :span="24" style="margin-bottom:20px;">
          <h3>{{$t('message.notes')}}</h3>
        </el-col>
        <p>{{$t('message.note01')}}</p>
        <p>{{$t('message.note02')}}</p>
        <p style="padding-bottom:30px;">{{$t('message.note03')}}</p>
      </el-row>
    </div>
  </div>
</template>
<script>
  import {
    getavailablemotorfactory,
    getmotortypelist
  }from '@/store/electric_load'
  export default {
    name: 'SelectedMotor',
    data() {
      return {
        options: [],
        selectedOptions: [],
        optionProps: {
          value: 'motor_factory',
          label: 'motor_factory',
        },
        options_2: [],
        selectedOptions_2: [],
        optionProps_2: {
          value: 'motor_type',
          label: 'motor_type',
        },
        tabPosition: 'left',
        motor_param: {},
        selectedSeries: this.$t('message.selectedSeries'),
        loadCondition: this.$t('message.loadCondition'),
        reducerSize: this.$t('message.reducerSize'),
        selectMotor: this.$t('message.selectMotor'),
        complete: this.$t('message.complete')
      };
    },
    props: {
      param_3:Object,
      required:true,
      param_compute_one:Object,
      required:true
    },
    methods: {
      returnPage:function(){
        sessionStorage.setItem('sign_num2', 'motor'); //为解bug设置一个缓存键
        this.$emit("listenPageChange","to_SizePage");
      },
      toNextPage:function(){
        if(this.motor_param.motor_factory && this.motor_param.motor_type){
          this.$emit("listenPageChange","to_CompletedPage");
          this.$emit("listenParam_4",this.motor_param);
        }else{
          this.$message({
            message: '请选择电机厂商 电机类型!',
            type: 'warning'
          });
        }
      },
      _getavailablemotorfactory:function(){
        getavailablemotorfactory(this.param_3).then((response)=>{
          if(response.success === true){
            this.options = [];
            this.options = response.data;
          }
        })
      },
      handleChange(val){
        this.motor_param.motor_factory = val[0];

        //clear
        this.motor_param.motor_type = '';
        this.options_2 = [];
      },
      handleChange_2(val){
        this.motor_param.motor_type = val[0];
      },
      // 获取电机型号列表
      _getmotortypelist() {
        this.motor_param.reducer_size = this.param_3.reducer_size;
        if(this.motor_param.motor_factory) {
          getmotortypelist(this.motor_param).then((response) => {
            if (response.success === true) {
              this.options_2 = response.data;
            }
          })
        }
      }
    }
  };
</script>
<style scoped>
  .content {
    width:100%;
    height: 100%;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
  }
  .top {
    height:100px;
    border-bottom:1px solid #EBEBEB;
  }
  .elec_speed {
    width:80%;
    margin:0 auto;
    padding-top:25px;
  }
  .el-steps {
    border-radius: 10px;
    background-color: #F5F7FA;
    background:url('../../../static/step.png') no-repeat #F5F7FA;
    background-size:20% 100%;
    background-position-x:78%;
  }
  .elec_select_left img{
    width: 250px;
    height: 250px;
    display: block;
    margin: 0 auto;
    padding-top: 100px;
  }
  .elec_select_left .text{
    text-align: center;
    font-weight: bold;
  }
  .el-cascader-menus el-popper{
    z-index: 2010;
    position: absolute;
    top: 284px;
    left: 952px;
  }
  .select_box {
    padding-left:10px;
    padding-top:130px;
  }
  .toNextPage {
    width:97px;
    height:42px;
    border-radius: 5px;
    background: #142479;
    text-align: center;
    line-height: 42px;
    color:white;
    margin-top:40px;
    cursor: pointer;
    display:inline-block;
  }
  .returnPage {
    width:97px;
    height:42px;
    border-radius: 5px;
    background: #142479;
    text-align: center;
    line-height: 42px;
    color:white;
    margin-top:40px;
    cursor: pointer;
    display:inline-block;
    margin-right:15px;
  }
  .elec_detail {
    width:80%;
    margin:0 auto;
    margin-top:70px;
    margin-left:200px;
    margin-bottom:50px;
  }
  .elec_detail p {
    color:#D0174B;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/LoadSelection/SelectedMotor.vue